import {
  FETCH_DEED_ADDRESS_FAIL,
  FETCH_DEED_ADDRESS_SUCCESS,
  FETCH_DEED_RECORDS_FAIL,
  FETCH_DEED_RECORDS_SUCCESS,
  RESET_DEED_REDUCER,
  SEARCH_DEED_DETAIL_FAIL,
  SEARCH_DEED_DETAIL_SUCCESS,
  UPLAOD_DEED_FAIL,
  UPLAOD_DEED_SUCCESS,
} from "../types/deedTypes";

const initState = {
  deedUploadSuccess: false,
  deedUploadError: false,
  deedUploadMessage: null,
  deedData: null,

  deedSearchSuccess: false,
  deedSearchError: false,
  deedSearchMessage: null,
  deedSearchData: null,

  deedRecordsSuccess: false,
  deedRecordsError: false,
  deedRecordsMessage: null,
  deedRecordsData: null,

  deedAddressSuccess: false,
  deedAddressError: false,
  deedAddressMessage: null,
  deedAddressData: null,
};

const deedReducer = (state = initState, action) => {
  switch (action.type) {
    case UPLAOD_DEED_SUCCESS:
      return {
        ...state,
        deedUploadSuccess: true,
        deedUploadError: false,
        deedUploadMessage: action.message || "Deed uploaded successfully.",
        deedData: action.payload,
      };
    case UPLAOD_DEED_FAIL:
      return {
        ...state,
        deedUploadSuccess: false,
        deedUploadError: true,
        deedUploadMessage: action.message || "Failed to upload deed.",
        deedData: null,
      };
    case SEARCH_DEED_DETAIL_SUCCESS:
      return {
        ...state,
        deedSearchSuccess: true,
        deedSearchError: false,
        deedSearchMessage: action.message || "Deed search successful.",
        deedSearchData: action.payload,
      };
    case SEARCH_DEED_DETAIL_FAIL:
      return {
        ...state,
        deedSearchSuccess: false,
        deedSearchError: true,
        deedSearchMessage: action.message || "Failed to search deed.",
        deedSearchData: null,
      };
    case FETCH_DEED_RECORDS_SUCCESS:
      return {
        ...state,
        deedRecordsSuccess: true,
        deedRecordsError: false,
        deedRecordsMessage:
          action.message || "Deed records fetched successfully.",
        deedRecordsData: action.payload,
      };
    case FETCH_DEED_RECORDS_FAIL:
      return {
        ...state,
        deedRecordsSuccess: false,
        deedRecordsError: true,
        deedRecordsMessage: action.message || "Failed to fetch deed records.",
        deedRecordsData: null,
      };
    case FETCH_DEED_ADDRESS_SUCCESS:
      return {
        ...state,
        deedAddressSuccess: true,
        deedAddressError: false,
        deedAddressMessage:
          action.message || "Deed address fetched successfully.",
        deedAddressData: action.payload,
      };
    case FETCH_DEED_ADDRESS_FAIL:
      return {
        ...state,
        deedAddressSuccess: false,
        deedAddressError: true,
        deedAddressMessage: action.message || "Failed to fetch deed address.",
        deedAddressData: null,
      };
    case RESET_DEED_REDUCER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default deedReducer;
